import React from 'react';
import PropTypes from 'prop-types';
import { DisabledState } from './disabledState';
import { EnabledState } from './enabledState';
import { SignupFormSkeleton } from './signupFormSkeleton';
import { useSignupForm } from './hooks/useSignupForm';

export const SignupForm = ({ sharedList, listAgentsEnabled }) => {
  const { formConfig, isLoadingForm, isCreating, error, isFormActive, handleEnableSignupForm } = useSignupForm({
    collectionId: sharedList.collection?.id,
    sharedListId: sharedList.id,
  });

  if (isLoadingForm) {
    return <SignupFormSkeleton />;
  }

  if (error || !formConfig || !isFormActive) {
    return <DisabledState isLoading={isCreating} onEnable={handleEnableSignupForm} />;
  }

  return <EnabledState sharedList={sharedList} formConfig={formConfig} listAgentsEnabled={listAgentsEnabled} />;
};

SignupForm.propTypes = {
  sharedList: PropTypes.shape({
    id: PropTypes.number,
    slug: PropTypes.string,
    signupFormEnabled: PropTypes.bool,
    collection: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  }).isRequired,
  listAgentsEnabled: PropTypes.bool.isRequired,
};
